import T from 'prop-types'
import React from 'react'
import ListInput from './ListInput'
import {
  validateDomain
} from 'pw-validators'
import { domainSanitizer } from '../draftUtils'

export default class DomainListInput extends React.Component {
  static displayName = 'DomainListInput'

  static propTypes = {
    className: T.string,
    initialValue: T.string,
    onChange: T.func,
    allowDuplicates: T.bool,
  }

  resetToInitialValue = () => {
    if (this._listInputRef) {
      this._listInputRef.resetToInitialValue()
    }
  }

  _handleListInputRef = (inst) => {
    this._listInputRef = inst
  }

  render() {
    return (
      <ListInput
        lineClassName={ `domain_list_item` }
        lineLabel={ "Domain" }
        lineValidator={ validateDomain }
        placeholder={ `example.com, www.example.com` }
        ref={ this._handleListInputRef }
        lineSanitizer={ domainSanitizer }
        { ...this.props }
      />
    )
  }
}
